import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, List, UncontrolledButtonDropdown } from 'reactstrap';
import { BsGraphUp } from '@react-icons/all-files/bs/BsGraphUp';
import { BsGrid3X2 } from '@react-icons/all-files/bs/BsGrid3X2';
import { BsGrid3X2Gap } from '@react-icons/all-files/bs/BsGrid3X2Gap';
import { BsGrid3X3GapFill } from '@react-icons/all-files/bs/BsGrid3X3GapFill';
import { BsGridFill } from '@react-icons/all-files/bs/BsGridFill';
import { BsMap } from '@react-icons/all-files/bs/BsMap';
import { BsPieChartFill } from '@react-icons/all-files/bs/BsPieChartFill';
import { BsTable } from '@react-icons/all-files/bs/BsTable';
import { DisplayListViewModel } from '../../DisplayFilters/DisplayListViewModel';
import { AppStore } from '../../Core/AppStore';
import { BsGrid3X3 } from 'react-icons/bs';

export enum DisplayGridViewTypes {
    Grid,
    MapView,
    LiveChartsView,
    Aggregate,
}

export interface IDisplayGridViewSelectorProps {
    readonly vm: DisplayListViewModel;
    readonly className?: string;
    readonly size?: 'md' | 'sm' | 'lg';
    readonly link?: boolean;
}

@autoinject
@observer
export class DisplayGridViewSelector extends React.Component<IDisplayGridViewSelectorProps> {
    public render() {
        return (
            <UncontrolledButtonDropdown className={this.props.className}>
                <DropdownToggle caret size={this.props.size ?? 'sm'} color={this.props.link ? 'link' : undefined}>
                    {this.iconClass}
                </DropdownToggle>

                <DropdownMenu end>
                    <DropdownItem
                        className={this.getItemClass(DisplayGridViewTypes.Grid)}
                        onClick={(e: any) => this.props.vm.onDisplayGridViewTypeChange(e, DisplayGridViewTypes.Grid)}
                    >
                        <BsTable /> Grid
                    </DropdownItem>
                    
                    <DropdownItem
                        className={this.getItemClass(DisplayGridViewTypes.MapView)}
                        onClick={(e: any) => {
                            this.props.vm.onDisplayGridViewTypeChange(e, DisplayGridViewTypes.MapView);
                        }}
                    >
                        <BsMap /> Map View
                    </DropdownItem>

                    <DropdownItem
                        className={this.getItemClass(DisplayGridViewTypes.LiveChartsView)}
                        onClick={(e: any) => {
                            this.props.vm.onDisplayGridViewTypeChange(e, DisplayGridViewTypes.LiveChartsView);
                        }}
                    >
                        <BsGraphUp /> Live Charts
                    </DropdownItem>

                    {/*<DropdownItem*/}
                    {/*    className={this.getItemClass(DisplayGridViewTypes.Aggregate)}*/}
                    {/*    onClick={(e: any) => this.props.vm.onDisplayGridViewTypeChange(e, DisplayGridViewTypes.Aggregate)}*/}
                    {/*>*/}
                    {/*    <BsPieChartFill /> Aggregate View*/}
                    {/*</DropdownItem>*/}
                </DropdownMenu>
            </UncontrolledButtonDropdown>
        );
    }

    @computed
    private get iconClass() {
        let icon;

        switch (this.props.vm.gridViewType) {
            default:
            case DisplayGridViewTypes.Grid:
                icon = <BsGrid3X3 />;
                break;
            case DisplayGridViewTypes.MapView:
                icon = <BsMap />;
                break;
            case DisplayGridViewTypes.LiveChartsView:
                icon = <BsGraphUp />;
                break;
            case DisplayGridViewTypes.Aggregate:
                icon = <BsPieChartFill />;
                break;
        }

        return icon;
    }

    private getItemClass(gridViewType: DisplayGridViewTypes) {
        if (this.props.vm.gridViewType == gridViewType) return 'active';
    }

    @inject
    private appStore!: AppStore;
}
